import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNorthEast = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.69999 19.3C4.51665 19.1167 4.42499 18.8833 4.42499 18.6C4.42499 18.3167 4.51665 18.0833 4.69999 17.9L15.6 7H9.99999C9.71665 7 9.47932 6.90433 9.28799 6.713C9.09599 6.521 8.99999 6.28333 8.99999 6C8.99999 5.71667 9.09599 5.479 9.28799 5.287C9.47932 5.09567 9.71665 5 9.99999 5H18C18.2833 5 18.5207 5.09567 18.712 5.287C18.904 5.479 19 5.71667 19 6V14C19 14.2833 18.904 14.5207 18.712 14.712C18.5207 14.904 18.2833 15 18 15C17.7167 15 17.4793 14.904 17.288 14.712C17.096 14.5207 17 14.2833 17 14V8.4L6.09999 19.3C5.91665 19.4833 5.68332 19.575 5.39999 19.575C5.11665 19.575 4.88332 19.4833 4.69999 19.3Z",
		fill: "currentColor"
	})
});
export default SvgNorthEast;
